import DomainResult from "components/searchResult/searchResult";
import { useAppDispatch } from "hooks";
import { memo, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import SlideDown from "react-slidedown";
import domainSlice from "reducers/domainSlice";
import styled from "styled-components";
import SearchResult from "types/searchResult";

interface AlternativesProps {
  alternatives: Array<SearchResult> | undefined;
}

const AnimatedSlideDown = styled(SlideDown)`
  transition-duration: 0.3s;
  transition-timing-function: linear;
  width: 100%;
`;

const SpinnerWrapper = styled.div`
  color: #6ba1f1;
  text-align: center;
  padding: 10px 0;
`;

const StyledDomainResult = styled(DomainResult)`
  @media only screen and (max-width: 576px) {
    padding-left: 13px !important;
    padding-right: 13px !important;
  }
`;

const Alternatives = (props: AlternativesProps) => {
  const dispatch = useAppDispatch();

  const { alternatives } = props;

  useEffect(() => {
    alternatives?.forEach((a) => {
      if (!a.loading && a.registered === undefined) {
        dispatch(
          domainSlice.actions.searchAlternativeDomainExtension(a.domain)
        );
      }
    });
  }, [alternatives, dispatch]);

  return (
    <AnimatedSlideDown>
      {!alternatives && (
        <SpinnerWrapper>
          <Spinner
            as="span"
            animation="border"
            role="status"
            size="sm"
            aria-hidden="true"
          />
        </SpinnerWrapper>
      )}
      {alternatives &&
        alternatives.map((a) => {
          return <StyledDomainResult key={a.domain} searchResult={a} />;
        })}
    </AnimatedSlideDown>
  );
};

export default memo(Alternatives);
